module.exports = __webpack_public_path__ + "img/42.285d5fcf.svg";